const { is } = require("bpmnlint-utils");

module.exports = function missingIncomingOrOutgoing() {
  return {
    check(node, reporter) {
      if (!node || !is(node, "bpmn:FlowNode")) {
        return;
      }

      const bo = node.businessObject || node;

      if (bo.$type === "bpmn:BoundaryEvent" && bo.attachedToRef) {
        return;
      }

      const incoming = Array.isArray(node.incoming) ? node.incoming : [];
      const outgoing = Array.isArray(node.outgoing) ? node.outgoing : [];

      if (is(node, "bpmn:StartEvent")) {
        if (outgoing.length === 0) {
          reporter.report(node.id, "Start Event must have at least one outgoing connection.");
        }
        return;
      }

      if (is(node, "bpmn:EndEvent")) {
        if (incoming.length === 0) {
          reporter.report(node.id, "End Event must have at least one incoming connection.");
        }
        return;
      }

      if (incoming.length === 0 || outgoing.length === 0) {
        reporter.report(node.id, "This element must have at least one incoming and one outgoing connection.");
      }
    }
  };
};
